import script from "./InvoiceDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceDetailModal.vue?vue&type=style&index=0&id=66d20cb2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66d20cb2"]])

export default __exports__